import { render, staticRenderFns } from "./aitutor3.vue?vue&type=template&id=06f56760&"
import script from "./aitutor3.vue?vue&type=script&lang=js&"
export * from "./aitutor3.vue?vue&type=script&lang=js&"
import style0 from "./aitutor3.vue?vue&type=style&index=0&id=06f56760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports